export const DOCUMENT_TYPE_PARTNERS_FRONTPAGE = 'partnersFrontpage';
